import React from 'react';
import Header from '../elements/Header';
import NextStep from '../elements/NextStep';
import PropTypes from 'prop-types';
import Defines from '../../Defines';
import { __ } from 'i18n-for-browser';

import DifficultyAwareComponent from "../DifficultyAwareComponent";
import ListButton from '../elements/ListButton';

import {ministryIcons} from '../../assets/assets.js';
import {
  renderMinistryFeedbackList,
} from "../../helpers/feedbackHelpers";
import connect from "react-redux/es/connect/connect";
/**
 * Import assets
 */

class Ministry extends DifficultyAwareComponent {
  static propTypes = {
    history: PropTypes.shape({}).isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      ministry: this.props.match.params.id.toUpperCase(),
    };
  }

  renderLaag() {
    const { gameState } = this.props;
    const {prevRoundSum} = gameState;
    const { ministry } = this.state;
    if(!prevRoundSum) return null;
    const fb = this.props.feedback.prevRoundFeedbackData.find(fb => fb.ministerie === this.state.ministry);
    if (fb) {
      this.props.history.replace(`/ministries/${ministry}/${fb.omschrijving}`);
    } else {
      this.props.history.goBack();
    }
    return null;
  }

  renderHoog() {
    const { gameState } = this.props;
    const {prevRoundSum} = gameState;
    const { ministry } = this.state;
    if(!prevRoundSum) return null;
    return (
      <div>
        <Header match={this.props.match} history={this.props.history} historic={false} buttonType='close' viewType='list' showTitle={false}/>

        <div className='container ministry-container'>
          <ListButton
            ministry={ministry}
            title={__(this.state.ministry)}
            icon={ministryIcons[this.state.ministry]}
            arrow={true}
            stars={Defines.ministeryStars[this.state.ministry]}
            points={prevRoundSum ? prevRoundSum[`${this.state.ministry}_points`] + '' : '...'}
            popupId={Defines.ministryPopupIds.pro[this.state.ministry]}
            global={Defines.i18nMinistries.includes(this.state.ministry)}
            disaster={false}
          />
          <div className='feedback-list'>
            { renderMinistryFeedbackList(this.props.feedback.prevRoundFeedbackData, this.state.ministry, this.props.gameState, this.props.gameStateInput) }
          </div>
        </div>

        <NextStep/>
      </div>
    );
  }
}

export default connect(({gameState, feedback, gameStateInput, project}) => ({gameState, feedback, gameStateInput, project}))(Ministry);



// WEBPACK FOOTER //
// ./src/components/routes/Ministry.js